export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/logoPERSONALCARE360.3a02ff71.svg";